import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  container: {
    height: "80vh",
  },
  dialogTitle: {
    margin: 0,
    padding: "16px 24px",
  },
  search: {
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "8px",
  },
  tableArea: {
    display: "flex",
    overflowY: "auto",
    height: "450px",
    marginTop: 2,
  },
  table: {
    padding: 0,
    border: "1px solid #ccc",
    "& th, & td": { border: "1px solid #ccc" },
  },
  tableCell: {
    padding: 0,
  },
  chipContainer: {
    width: "100%",
    height: "450px",
    overflowY: "auto",
    marginTop: 3,
    paddingRight: 1,
  },
  chip: {
    cursor: "grab",
    width: "100%",
    marginBottom: 1
  },
};
